import * as React from "react";
const SvgFiRrSpade = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-spade_svg__a)">
      <path
        fill="#062147"
        d="M23 13.5c0-4.363-4.846-9.756-7.71-12.255a5.03 5.03 0 0 0-6.582 0C5.846 3.745 1 9.138 1 13.5A6.27 6.27 0 0 0 7 20a5.82 5.82 0 0 0 3.93-1.658C10.75 20.805 10.114 22 8 22H6a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2h-2c-2.116 0-2.75-1.2-2.93-3.658A5.82 5.82 0 0 0 17 20a6.27 6.27 0 0 0 6-6.5m-10.1 1.417a1 1 0 0 0-.9-.552 1 1 0 0 0-.893.55C11.09 14.945 9.514 18 7 18a4.277 4.277 0 0 1-4-4.5c0-3.032 3.533-7.7 7.023-10.747a3.02 3.02 0 0 1 3.954 0C17.467 5.8 21 10.47 21 13.5a4.277 4.277 0 0 1-4 4.5c-2.515 0-4.091-3.055-4.1-3.083"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-spade_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSpade;
